import { useState } from "react";

interface HeroProps {
  onSearch: (kw: string) => void;
}

const badges = ["治愈系", "日常系", "温馨番剧", "萌系动画"];

export default function Hero({ onSearch }: HeroProps) {
  const [kw, setKw] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(kw);
    document.getElementById("list")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=warm%20cozy%20anime%20background%20art%20of%20a%20sunset%20meadow%20with%20soft%20glowing%20fireflies%2C%20floating%20gently%20toward%20a%20starry%20evening%20sky%2C%20dreamy%20pastel%20orange%20peach%20and%20cream%20palette%2C%20stylized%20illustration%20with%20soft%20bokeh%20lights%2C%20peaceful%20healing%20and%20heartwarming%20atmosphere%2C%20no%20text%20no%20characters&width=1600&height=900&seq=hero-anime-2026&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-background-50"></div>

      <div className="relative mx-auto flex min-h-[640px] max-w-7xl w-full flex-col items-center justify-center px-4 pt-24 pb-16 text-center md:min-h-[680px] md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm text-white backdrop-blur">
          <i className="ri-heart-3-fill text-primary-200"></i>
          治愈 · 日常 · 温馨 · 萌系 一站式收录
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          小狗看番
          <span className="ml-3 hidden text-primary-200 md:inline">治愈系推荐</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          想放松心情、找暖心番单？我们把治愈、日常、温馨、萌系的好番都整理成了片单。
          每部都标注看点与集数，省去翻评论找番的时间，直接按片单追更。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
        >
          <label className="flex flex-1 items-center gap-3 rounded-md bg-white px-4 py-3 text-sm text-foreground-700">
            <i className="ri-search-line text-base text-foreground-400"></i>
            <input
              type="text"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜一部想看的番，比如「夏目友人帐」"
              className="w-full bg-transparent outline-none"
            />
          </label>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追番
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {badges.map((b) => (
            <button
              key={b}
              type="button"
              onClick={() => {
                onSearch(b);
                document.getElementById("list")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="whitespace-nowrap rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur transition-colors hover:bg-white/20"
            >
              {b}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}